import _regeneratorRuntime from "/builds/node_modules/@babel/runtime/regenerator/index.js";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(take),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(takeMaybe),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(takeEvery),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(takeLatest),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(takeLeading),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(put),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(putResolve),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(call),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(apply),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(cps),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(fork),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(spawn),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(join),
    _marked14 = /*#__PURE__*/_regeneratorRuntime.mark(cancel),
    _marked15 = /*#__PURE__*/_regeneratorRuntime.mark(select),
    _marked16 = /*#__PURE__*/_regeneratorRuntime.mark(actionChannel),
    _marked17 = /*#__PURE__*/_regeneratorRuntime.mark(flush),
    _marked18 = /*#__PURE__*/_regeneratorRuntime.mark(cancelled),
    _marked19 = /*#__PURE__*/_regeneratorRuntime.mark(setContext),
    _marked20 = /*#__PURE__*/_regeneratorRuntime.mark(getContext),
    _marked21 = /*#__PURE__*/_regeneratorRuntime.mark(delay),
    _marked22 = /*#__PURE__*/_regeneratorRuntime.mark(throttle),
    _marked23 = /*#__PURE__*/_regeneratorRuntime.mark(debounce),
    _marked24 = /*#__PURE__*/_regeneratorRuntime.mark(retry),
    _marked25 = /*#__PURE__*/_regeneratorRuntime.mark(all),
    _marked26 = /*#__PURE__*/_regeneratorRuntime.mark(race);

import { take as take$1, takeMaybe as takeMaybe$1, takeEvery as takeEvery$1, takeLatest as takeLatest$1, takeLeading as takeLeading$1, put as put$1, putResolve as putResolve$1, call as call$1, apply as apply$1, cps as cps$1, fork as fork$1, spawn as spawn$1, join as join$1, cancel as cancel$1, select as select$1, actionChannel as actionChannel$1, flush as flush$1, cancelled as cancelled$1, setContext as setContext$1, getContext as getContext$1, delay as delay$1, throttle as throttle$1, debounce as debounce$1, retry as retry$1, all as all$1, race as race$1 } from 'redux-saga/effects';
/* This file is generated. Do not edit it. */

/* This file is generated. Do not edit it. */

function take() {
  var _args = arguments;
  return _regeneratorRuntime.wrap(function take$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return take$1.apply(void 0, _args);

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/* This file is generated. Do not edit it. */


function takeMaybe() {
  var _args2 = arguments;
  return _regeneratorRuntime.wrap(function takeMaybe$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeMaybe$1.apply(void 0, _args2);

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/* This file is generated. Do not edit it. */


function takeEvery() {
  var _args3 = arguments;
  return _regeneratorRuntime.wrap(function takeEvery$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeEvery$1.apply(void 0, _args3);

        case 2:
          return _context3.abrupt("return", _context3.sent);

        case 3:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/* This file is generated. Do not edit it. */


function takeLatest() {
  var _args4 = arguments;
  return _regeneratorRuntime.wrap(function takeLatest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest$1.apply(void 0, _args4);

        case 2:
          return _context4.abrupt("return", _context4.sent);

        case 3:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/* This file is generated. Do not edit it. */


function takeLeading() {
  var _args5 = arguments;
  return _regeneratorRuntime.wrap(function takeLeading$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return takeLeading$1.apply(void 0, _args5);

        case 2:
          return _context5.abrupt("return", _context5.sent);

        case 3:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/* This file is generated. Do not edit it. */


function put() {
  var _args6 = arguments;
  return _regeneratorRuntime.wrap(function put$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return put$1.apply(void 0, _args6);

        case 2:
          return _context6.abrupt("return", _context6.sent);

        case 3:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/* This file is generated. Do not edit it. */


function putResolve() {
  var _args7 = arguments;
  return _regeneratorRuntime.wrap(function putResolve$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return putResolve$1.apply(void 0, _args7);

        case 2:
          return _context7.abrupt("return", _context7.sent);

        case 3:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/* This file is generated. Do not edit it. */


function call() {
  var _args8 = arguments;
  return _regeneratorRuntime.wrap(function call$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return call$1.apply(void 0, _args8);

        case 2:
          return _context8.abrupt("return", _context8.sent);

        case 3:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
/* This file is generated. Do not edit it. */


function apply() {
  var _args9 = arguments;
  return _regeneratorRuntime.wrap(function apply$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return apply$1.apply(void 0, _args9);

        case 2:
          return _context9.abrupt("return", _context9.sent);

        case 3:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}
/* This file is generated. Do not edit it. */


function cps() {
  var _args10 = arguments;
  return _regeneratorRuntime.wrap(function cps$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return cps$1.apply(void 0, _args10);

        case 2:
          return _context10.abrupt("return", _context10.sent);

        case 3:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}
/* This file is generated. Do not edit it. */


function fork() {
  var _args11 = arguments;
  return _regeneratorRuntime.wrap(function fork$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return fork$1.apply(void 0, _args11);

        case 2:
          return _context11.abrupt("return", _context11.sent);

        case 3:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}
/* This file is generated. Do not edit it. */


function spawn() {
  var _args12 = arguments;
  return _regeneratorRuntime.wrap(function spawn$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return spawn$1.apply(void 0, _args12);

        case 2:
          return _context12.abrupt("return", _context12.sent);

        case 3:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}
/* This file is generated. Do not edit it. */


function join() {
  var _args13 = arguments;
  return _regeneratorRuntime.wrap(function join$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return join$1.apply(void 0, _args13);

        case 2:
          return _context13.abrupt("return", _context13.sent);

        case 3:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}
/* This file is generated. Do not edit it. */


function cancel() {
  var _args14 = arguments;
  return _regeneratorRuntime.wrap(function cancel$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return cancel$1.apply(void 0, _args14);

        case 2:
          return _context14.abrupt("return", _context14.sent);

        case 3:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}
/* This file is generated. Do not edit it. */


function select() {
  var _args15 = arguments;
  return _regeneratorRuntime.wrap(function select$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return select$1.apply(void 0, _args15);

        case 2:
          return _context15.abrupt("return", _context15.sent);

        case 3:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}
/* This file is generated. Do not edit it. */


function actionChannel() {
  var _args16 = arguments;
  return _regeneratorRuntime.wrap(function actionChannel$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return actionChannel$1.apply(void 0, _args16);

        case 2:
          return _context16.abrupt("return", _context16.sent);

        case 3:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16);
}
/* This file is generated. Do not edit it. */


function flush() {
  var _args17 = arguments;
  return _regeneratorRuntime.wrap(function flush$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return flush$1.apply(void 0, _args17);

        case 2:
          return _context17.abrupt("return", _context17.sent);

        case 3:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17);
}
/* This file is generated. Do not edit it. */


function cancelled() {
  var _args18 = arguments;
  return _regeneratorRuntime.wrap(function cancelled$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return cancelled$1.apply(void 0, _args18);

        case 2:
          return _context18.abrupt("return", _context18.sent);

        case 3:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18);
}
/* This file is generated. Do not edit it. */


function setContext() {
  var _args19 = arguments;
  return _regeneratorRuntime.wrap(function setContext$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return setContext$1.apply(void 0, _args19);

        case 2:
          return _context19.abrupt("return", _context19.sent);

        case 3:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked19);
}
/* This file is generated. Do not edit it. */


function getContext() {
  var _args20 = arguments;
  return _regeneratorRuntime.wrap(function getContext$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return getContext$1.apply(void 0, _args20);

        case 2:
          return _context20.abrupt("return", _context20.sent);

        case 3:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked20);
}
/* This file is generated. Do not edit it. */


function delay() {
  var _args21 = arguments;
  return _regeneratorRuntime.wrap(function delay$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return delay$1.apply(void 0, _args21);

        case 2:
          return _context21.abrupt("return", _context21.sent);

        case 3:
        case "end":
          return _context21.stop();
      }
    }
  }, _marked21);
}
/* This file is generated. Do not edit it. */


function throttle() {
  var _args22 = arguments;
  return _regeneratorRuntime.wrap(function throttle$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return throttle$1.apply(void 0, _args22);

        case 2:
          return _context22.abrupt("return", _context22.sent);

        case 3:
        case "end":
          return _context22.stop();
      }
    }
  }, _marked22);
}
/* This file is generated. Do not edit it. */


function debounce() {
  var _args23 = arguments;
  return _regeneratorRuntime.wrap(function debounce$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return debounce$1.apply(void 0, _args23);

        case 2:
          return _context23.abrupt("return", _context23.sent);

        case 3:
        case "end":
          return _context23.stop();
      }
    }
  }, _marked23);
}
/* This file is generated. Do not edit it. */


function retry() {
  var _args24 = arguments;
  return _regeneratorRuntime.wrap(function retry$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return retry$1.apply(void 0, _args24);

        case 2:
          return _context24.abrupt("return", _context24.sent);

        case 3:
        case "end":
          return _context24.stop();
      }
    }
  }, _marked24);
}
/* This file is generated. Do not edit it. */


function all() {
  var _args25 = arguments;
  return _regeneratorRuntime.wrap(function all$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return all$1.apply(void 0, _args25);

        case 2:
          return _context25.abrupt("return", _context25.sent);

        case 3:
        case "end":
          return _context25.stop();
      }
    }
  }, _marked25);
}
/* This file is generated. Do not edit it. */


function race() {
  var _args26 = arguments;
  return _regeneratorRuntime.wrap(function race$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return race$1.apply(void 0, _args26);

        case 2:
          return _context26.abrupt("return", _context26.sent);

        case 3:
        case "end":
          return _context26.stop();
      }
    }
  }, _marked26);
}

export { actionChannel, all, apply, call, cancel, cancelled, cps, debounce, delay, flush, fork, getContext, join, put, putResolve, race, retry, select, setContext, spawn, take, takeEvery, takeLatest, takeLeading, takeMaybe, throttle };